var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67507 15.2H9.69368C13.3305 15.2 14.8844 13.6462 14.8844 10.0094V8.66982C14.8844 8.39521 14.6567 8.16749 14.382 8.16749C14.1074 8.16749 13.8797 8.39521 13.8797 8.66982V10.0094C13.8797 13.097 12.7813 14.1954 9.69368 14.1954H5.67507C2.58744 14.1954 1.48903 13.097 1.48903 10.0094V5.99075C1.48903 2.90312 2.58744 1.8047 5.67507 1.8047H7.01461C7.28921 1.8047 7.51693 1.57698 7.51693 1.30237C7.51693 1.02777 7.28921 0.800049 7.01461 0.800049H5.67507C2.03824 0.800049 0.484375 2.35391 0.484375 5.99075V10.0094C0.484375 13.6462 2.03824 15.2 5.67507 15.2ZM14.3821 5.01958C14.1075 5.01958 13.8797 4.79186 13.8797 4.51726V2.51464L8.70912 7.68525C8.60865 7.78572 8.4814 7.8326 8.35414 7.8326C8.22689 7.8326 8.09963 7.78572 7.99917 7.68525C7.80493 7.49102 7.80493 7.16953 7.99917 6.9753L13.1698 1.8047H11.1672C10.8926 1.8047 10.6648 1.57698 10.6648 1.30237C10.6648 1.02777 10.8926 0.800049 11.1672 0.800049H14.3821C14.6567 0.800049 14.8844 1.02777 14.8844 1.30237V4.51726C14.8844 4.79186 14.6567 5.01958 14.3821 5.01958Z",
    fill: "#5A5C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.74b1f79beb38be8e315c1327b621f38a.svg";
export { ForwardRef as ReactComponent };